import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import { CONFIRMATION_VALUE } from "../../../../utils/constant.utils";
import { InputFieldFloatingLabel as InputField } from "../../custom-form/select-filter.component";
import { MAX_LENGTH, TYPE_FUNCTION } from "../../../../constants/external-constants";
import DATEPICKER_OR from "../../custom-form/custom-date-picker.component";
import Translation from '../../translation/translation.component';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import store from '../../../../store';
import "./form-modal.css"
import { Loading } from "../../loading";
class ModalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            details:[]
        }
    }

   
    handelAcceptConfirmation = () => {

        if (typeof this.props.SaveDetails === TYPE_FUNCTION) {  
            this.props.SaveDetails();
        } else {
            if (typeof this.props.handleModal === TYPE_FUNCTION) {  
                this.props.handleModal()
           }
        }
    }   


    SelectDate =(date)=>{       
        store.dispatch(actions.change(this.props.dateFieldProps, date));
    }
    render() {
        const { followUpDetails, existing, dataLoading, isReadAndWrite } = this.props;
        const modalRoot = typeof document !== "undefined" ? document.getElementById("modal-root") : null;
        return (
            <>
                <Modal
                    show={this.props.show}
                    onHide={this.props.handleModal}
                    backdrop="static"
                    keyboard={false}
                    enforceFocus={false}
                    restoreFocus={false}
                    container={modalRoot || undefined}
                    className={`custom-column-modal-container form-modal-container ${this.props.customClass}`}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.title ? <Translation translationKey={this.props.title}/> : "Modal Title" }</Modal.Title>
                    </Modal.Header>
                    {
                        dataLoading ?
                            <Loading />
                        :
                        <>
                            <Modal.Body>                      
                                <div className="message-form-body">
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={this.props.textLabel ? <Translation translationKey={this.props.textLabel} /> : "Text Field"}
                                        value={followUpDetails ?? ""}
                                        fieldProp={this.props.detailsFieldProps ? this.props.detailsFieldProps : ".fieldProps"}
                                        maxLength={MAX_LENGTH.limit_255}
                                        placeholder={"Enter text here..."}
                                        disabled={existing}
                                    />
                                    <DATEPICKER_OR
                                        dateOnly={true} 
                                        label={this.props.dateLabel ? <Translation translationKey={this.props.dateLabel} /> : "Select Date"} 
                                        placeholder={"Select..."}
                                        startDate={this.props.followUpDate ? this.props.followUpDate : new Date()} 
                                        selectedDate={(date) => this.SelectDate(date)}
                                        minDate={this.props.minDate}
                                        maxDate={this.props.maxDate}
                                        requiredField={true}
                                        isDisable={existing}
                                    />
                                </div>                      
                            </Modal.Body>
                            <Modal.Footer>
                                {isReadAndWrite &&<Button variant="secondary" className={`custom-btn-color ${existing ? "hidden" : ""}`} onClick={() => this.handelAcceptConfirmation()}>Save Changes</Button>}
                            </Modal.Footer>
                        </>
                    }
                    
                </Modal>
            </>
        );
    }
}

export default ModalForm;